import React, { useState } from 'react';
import moment from 'moment-jalaali';

// تنظیم لوکال افغانستان
moment.locale('fa', {
  months: ['حمل', 'ثور', 'جوزا', 'سرطان', 'اسد', 'سنبله', 'میزان', 'عقرب', 'قوس', 'جدی', 'دلو', 'حوت'],
  weekdays: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'],
  weekdaysShort: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش']
});

export default function ShamsiDatePicker({ value, onChange, placeholder, className }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(value ? moment(value) : moment());
  
  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (onChange) onChange(date.toDate());
    setIsOpen(false);
  };
  
  const getMonthName = (date) => {
    const months = ['حمل', 'ثور', 'جوزا', 'سرطان', 'اسد', 'سنبله', 'میزان', 'عقرب', 'قوس', 'جدی', 'دلو', 'حوت'];
    return months[date.jMonth()];
  };
  
  // گرفتن تعداد روزهای ماه جاری
  const getDaysInMonth = (date) => {
    const year = date.jYear();
    const month = date.jMonth();
    const firstDayOfMonth = moment(`${year}/${month + 1}/1`, 'jYYYY/jM/jD');
    const lastDayOfMonth = firstDayOfMonth.clone().endOf('jMonth');
    return lastDayOfMonth.jDate();
  };
  
  // گرفتن روز شروع ماه (چندمین روز هفته)
  const getStartDayOfWeek = (date) => {
    const year = date.jYear();
    const month = date.jMonth();
    const firstDay = moment(`${year}/${month + 1}/1`, 'jYYYY/jM/jD');
    return firstDay.day();
  };
  
  const renderCalendar = () => {
    const daysInMonth = getDaysInMonth(selectedDate);
    const startDay = getStartDayOfWeek(selectedDate);
    const today = moment();
    const currentYear = selectedDate.jYear();
    const currentMonth = selectedDate.jMonth();
    
    const days = [];
    
    // روزهای خالی ابتدای ماه
    for (let i = 0; i < startDay; i++) {
      days.push(<div key={`empty-${i}`} className="py-1"></div>);
    }
    
    // روزهای ماه
    for (let day = 1; day <= daysInMonth; day++) {
      const isToday = day === today.jDate() && currentYear === today.jYear() && currentMonth === today.jMonth();
      days.push(
        <button
          key={day}
          onClick={() => handleDateChange(moment(`${currentYear}/${currentMonth + 1}/${day}`, 'jYYYY/jM/jD'))}
          className={`py-1 rounded-lg text-sm transition-colors
            ${isToday ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          {day}
        </button>
      );
    }
    
    return days;
  };
  
  return (
    <div className="relative">
      <input
        type="text"
        className={className || "form-input bg-gray-50 border-gray-200 text-gray-800 rounded-xl cursor-pointer"}
        value={selectedDate.format('jYYYY/jMM/jDD')}
        onClick={() => setIsOpen(!isOpen)}
        readOnly
        placeholder={placeholder || "1403/01/15"}
      />
      
      {isOpen && (
        <div className="absolute z-[9999] mt-1 bg-white border border-gray-200 rounded-xl shadow-xl p-3 w-72">
          {/* ماه و سال */}
          <div className="flex justify-between items-center mb-3">
            <button 
              onClick={() => setSelectedDate(moment(selectedDate).subtract(1, 'jMonth'))}
              className="text-gray-800 hover:text-blue-600 px-2 py-1"
            >
              ‹
            </button>
            <span className="text-gray-800 font-bold">
              {getMonthName(selectedDate)} {selectedDate.jYear()}
            </span>
            <button 
              onClick={() => setSelectedDate(moment(selectedDate).add(1, 'jMonth'))}
              className="text-gray-800 hover:text-blue-600 px-2 py-1"
            >
              ›
            </button>
          </div>
          
          {/* روزهای هفته */}
          <div className="grid grid-cols-7 gap-1 mb-2 text-center">
            {['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'].map(day => (
              <div key={day} className="text-gray-500 text-xs py-1">{day}</div>
            ))}
          </div>
          
          {/* روزهای ماه */}
          <div className="grid grid-cols-7 gap-1">
            {renderCalendar()}
          </div>
          
          {/* دکمه امروز */}
          <div className="mt-3 pt-2 border-t border-gray-200 flex justify-between">
            <button 
              onClick={() => handleDateChange(moment())}
              className="text-xs text-blue-600 hover:text-blue-700"
            >
              امروز
            </button>
            <button 
              onClick={() => setIsOpen(false)}
              className="text-xs text-gray-500 hover:text-gray-600"
            >
              بستن
            </button>
          </div>
        </div>
      )}
    </div>
  );
}